import { AnimationFunction } from '@opten/animation/animation-function';
import { linearTween } from '@opten/animation/linear-tween';
import { scrollToElement } from '../scroll-to-element';

export function scrollToId(
	id: string,
	animationFunction: AnimationFunction = linearTween,
	duration = 300,
	offset = 0,
	wrapper: HTMLElement | Window = window
) {
	return scrollToElement(
		document.getElementById(id),
		animationFunction,
		duration,
		offset,
		wrapper
	);
}
